import { render, staticRenderFns } from "./borderComp.vue?vue&type=template&id=59443898&"
import script from "./borderComp.vue?vue&type=script&lang=js&"
export * from "./borderComp.vue?vue&type=script&lang=js&"
import style0 from "./borderComp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports